export default {
  methods: {
    getSoundtrackDisplay(soundtrack) {
      return soundtrack.language.code +
        (soundtrack.audioDescriptive ? ' [AD]' : '');
    },
    getSoundtrackDisplayFull(soundtrack) {
      const name = soundtrack.language.name ?? soundtrack.language.code ?? '';

      return name +
        (soundtrack.audioDescriptive ? ' [AD]' : '');
    },
    soundtracksMatch(a, b) {
      return a.language.id === b.language.id &&
        a.audioDescriptive === b.audioDescriptive;
    },
  },
};
